// extracted by mini-css-extract-plugin
module.exports = {"focused":"_1SxNO","root":"elK-9","container":"_1N-As","expanded":"_1WJAQ"};